import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import { Link as RouterLink } from 'react-router-dom';
import { alpha, useTheme } from '@material-ui/core/styles';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import StarIcon from '@material-ui/icons/Star';
import {
  commercialBundles,
  countCommercialOffers,
  getTeaserFeaturedProducts,
} from '../../../../data/commercialPackagesData';

const PaquetesTeaser = () => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const secondary = theme.palette.secondary?.main || '#00838f';
  const featuredProducts = getTeaserFeaturedProducts();
  const totalOffers = countCommercialOffers();

  return (
    <Box
      sx={{
        borderRadius: 4,
        overflow: 'hidden',
        background: `linear-gradient(165deg, ${alpha(primary, 0.05)} 0%, ${alpha(secondary, 0.09)} 45%, transparent 100%)`,
        px: { xs: 1, md: 2 },
        py: { xs: 3, md: 4 },
      }}
    >
      <Box marginBottom={3} textAlign="center">
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 700, letterSpacing: 2 }}
          gutterBottom
          color="secondary"
        >
          Portafolio comercial
        </Typography>
        <Box component={Typography} fontWeight={900} variant="h4" gutterBottom color="primary">
          Productos y paquetes
        </Box>
        <Typography variant="body1" color="textSecondary" sx={{ maxWidth: 640, mx: 'auto', mb: 2 }}>
          Micros, rotativas, Digest, coberturas y paquetes integrados con precios referenciales en USD/mes.
        </Typography>
        <Chip
          icon={<ShoppingCartIcon />}
          label={`${totalOffers} opciones · productos y paquetes`}
          sx={{
            fontWeight: 700,
            bgcolor: alpha(primary, 0.1),
            color: primary,
            border: `1px solid ${alpha(primary, 0.2)}`,
          }}
        />
      </Box>

      <Grid container spacing={2} sx={{ mb: 3, maxWidth: 1000, mx: 'auto' }}>
        {commercialBundles.map((bundle) => (
          <Grid item xs={12} md={4} key={bundle.id}>
            <Box
              sx={{
                borderRadius: 3,
                height: '100%',
                p: 2.5,
                border: bundle.highlighted
                  ? `2px solid ${bundle.accent}`
                  : `1px solid ${alpha(bundle.accent, 0.25)}`,
                bgcolor: theme.palette.background.paper,
                boxShadow: bundle.highlighted
                  ? `0 12px 32px ${alpha(bundle.accent, 0.2)}`
                  : `0 6px 20px ${alpha(primary, 0.06)}`,
              }}
            >
              {bundle.badge ? (
                <Chip
                  size="small"
                  icon={bundle.highlighted ? <StarIcon sx={{ fontSize: '14px !important' }} /> : undefined}
                  label={bundle.badge}
                  sx={{
                    mb: 1.25,
                    fontWeight: 700,
                    fontSize: '0.68rem',
                    bgcolor: bundle.accent,
                    color: '#fff',
                    height: 'auto',
                    maxWidth: '100%',
                    '& .MuiChip-label': { whiteSpace: 'normal', lineHeight: 1.3, py: 0.5 },
                  }}
                />
              ) : null}
              <Typography sx={{ fontWeight: 800, fontSize: '1.05rem', mb: 0.5 }}>
                {bundle.name}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 1 }}>
                <Typography sx={{ fontWeight: 900, fontSize: '1.85rem', color: bundle.accent }}>
                  ${bundle.price}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {bundle.priceNote}
                </Typography>
              </Box>
              <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.5, fontSize: '0.88rem' }}>
                {bundle.summary}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={1.5} sx={{ mb: 3, maxWidth: 920, mx: 'auto' }}>
        {featuredProducts.map((product) => (
          <Grid item xs={6} sm={3} key={product.id}>
            <Box
              sx={{
                borderRadius: 2.5,
                px: 1.5,
                py: 1.25,
                textAlign: 'center',
                border: `1px solid ${alpha(product.accent, 0.25)}`,
                bgcolor: alpha(product.accent, 0.06),
              }}
            >
              <Typography sx={{ fontWeight: 800, fontSize: '1.1rem', color: product.accent, lineHeight: 1.1 }}>
                ${product.price}
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.68rem',
                  fontWeight: 700,
                  lineHeight: 1.25,
                  mt: 0.5,
                  color: 'text.secondary',
                }}
              >
                {product.name}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box textAlign="center">
        <Button
          component={RouterLink}
          to="/paquetes"
          variant="contained"
          color="primary"
          size="large"
          startIcon={<ShoppingCartIcon />}
          endIcon={<ArrowForwardIcon />}
          sx={{ borderRadius: 999, px: 3, fontWeight: 700 }}
        >
          Ver catálogo y precios
        </Button>
      </Box>
    </Box>
  );
};

export default PaquetesTeaser;
